import {MessageCodes} from "../MessageCodes";
import ResultText from "../ResultText";
import CheckCSName from "../../CheckCSName";
import NO_OUT_Component from "../NO_OUT_Component";
import ResultTable from "../../Table/ResultTable";
import ResultHeader from "../../Table/ResultHeader";
import ResultRow from "../../Table/ResultRow";
import ResultBody from "../../Table/ResultBody";
import ResultHeaderCell from "../../Table/ResultHeaderCell";
import ResultBodyCell from "../../Table/ResultBodyCell";
import EmptyLine from "../../EmptyLine";
import StationElevationPlot from "../UI/StationElevationPlot";
import {useModal} from "../../../Context/ModalContext";
import {useUser} from "../../../Context/UserContext";
import HecRasHelper from "../../../Helpers/HecRasHelper";
import ResultView from "../../V2/ResultView";

export function B2({data, message_key}) {
    const {settings} = useUser()

    return (
        <>
            {
                data?.result?.map(row => (
                    <ResultView error_id={row?.error_id} message_key={message_key}>
                        <Description row={row} settings={settings} globalVariables={data?.global_variables} />
                    </ResultView>
                ))
            }
        </>
    )
}

const StaElevPlot = ({riverStation, globalVariables, layers}) => {
    return (
        <>
            <StationElevationPlot
                crossSection={riverStation?.cross_section}
                plotData={{
                    base: riverStation?.plot_base
                }}
                globalVariables={globalVariables}
                layers={layers}
            />
        </>
    )
}

const Description = ({text, row, settings, globalVariables}) => {
    const {openModal} = useModal()

    switch (row.error_id) {
        case MessageCodes.Internal.ENCR001.error_id: {
            return (
                <>
                    <ResultText>
                        There are issues with the encroachment station placement at the following cross sections.
                        <EmptyLine />
                    </ResultText>
                    <ResultTable data={row}>
                        <ResultHeader>
                            <ResultRow>
                                <ResultHeaderCell style={{textAlign: 'left', width: HecRasHelper.getWidth(15)}}>River Station</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'right', width: HecRasHelper.getWidth(15)}}>Bank</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'right', width: HecRasHelper.getWidth(30)}}>Issue</ResultHeaderCell>
                            </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                            {
                                row?.data?.map(r => (
                                    <ResultRow>
                                        <ResultBodyCell style={{textAlign: 'left'}}>
                                            <CheckCSName
                                                csNameVal={r.cross_section}
                                                csName={r.cross_section}
                                            />
                                        </ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'right'}}>{r.side || 'left'}</ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'right'}}>{r.issue}</ResultBodyCell>
                                    </ResultRow>
                                ))
                            }
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }

        case MessageCodes.Internal.ENCR00.error_id: {
            return (
                <ResultText>
                    {row.error_message}
                </ResultText>
            )
        }
        case MessageCodes.Internal.B2_NOOUT01.error_id: {
            return (
                <>
                    <NO_OUT_Component error={row}/>
                </>
            )
        }
        case MessageCodes.Internal.B2_NOOUT02.error_id: {
            return (
                <>
                    <NO_OUT_Component error={row}/>
                </>
            )
        }
        default: {
            return `Error Key Not Found: ${row.error_id}`
        }
    }
}